const CF_MAIN_DOMAIN = 'creativefabrica.com'

const ALLOWED_DOMAINS_CONFIG = [
  {
    domain: 'instagram.com',
    allowedPath: '/creativefabrica',
  },
  {
    domain: 'facebook.com',
    allowedPath: '/creativefabricacom',
  },
  {
    domain: 'pinterest.com',
    allowedPath: '/creafabrica',
  },
  {
    domain: 'youtube.com',
    allowedPath: '/@creativefabricastudio',
  },
  {
    domain: 'linkedin.com',
    allowedPath: '/company/creative-fabrica',
  },
  {
    domain: 'tiktok.com',
    allowedPath: '/@creativefabrica.com',
  },
] as const

function matchesDomainOrSubdomain(hostname: string, domain: string) {
  return hostname === domain || hostname.endsWith(`.${domain}`)
}

function matchesAllowedPath(pathname: string, allowedPath: string) {
  return pathname === allowedPath || pathname.startsWith(`${allowedPath}/`)
}

export function isAllowedLink(url: URL) {
  const hostname = url.hostname.toLowerCase()
  const pathname = url.pathname.toLowerCase()

  if (matchesDomainOrSubdomain(hostname, CF_MAIN_DOMAIN)) {
    return true
  }

  return ALLOWED_DOMAINS_CONFIG.some(domainConfig => {
    return (
      matchesDomainOrSubdomain(hostname, domainConfig.domain) &&
      matchesAllowedPath(pathname, domainConfig.allowedPath)
    )
  })
}
